import { resources } from '../../app/src/i18n/resources';
import {
  AdminApiError,
  type PendingQuote,
  type PendingReviewerOption,
  type AdminReviewFilters,
} from './admin-api';
export const quoteModerationCopy = resources.en.translation.quoteModeration;
const c = quoteModerationCopy;
export type ModerationKind = 'shared' | 'wording' | 'thought';
export interface QuoteModerationItem extends Omit<PendingQuote, 'readerId'> {
  readerId: string | null;
  kind: ModerationKind;
  status: 'pending' | 'approved' | 'hidden';
  publishedBody: string | null;
  readerCount: number;
  containsSpoilers: boolean;
  quote?: {
    id: string;
    body: string;
    version: number;
    status: 'approved' | 'unreviewed' | 'hidden';
    language: string;
    captureVersion: number;
  } | null;
}
export interface Queue {
  items: QuoteModerationItem[];
  total: number;
  nextCursor: string | null;
  readers: PendingReviewerOption[];
}
export function parseQuoteModerationQueue(input: unknown): Queue {
  const value = input as Queue;
  if (
    !value ||
    !Array.isArray(value.items) ||
    !Number.isSafeInteger(value.total) ||
    value.total < 0 ||
    !Array.isArray(value.readers) ||
    (value.nextCursor !== null && typeof value.nextCursor !== 'string') ||
    value.items.some(
      (item) =>
        !item ||
        !['shared', 'wording', 'thought'].includes(item.kind) ||
        !['pending', 'approved', 'hidden'].includes(item.status) ||
        typeof item.id !== 'string' ||
        typeof item.body !== 'string' ||
        !Number.isSafeInteger(item.version) ||
        item.version < 1 ||
        !item.book ||
        typeof item.book.title !== 'string' ||
        !Array.isArray(item.book.authors) ||
        item.book.authors.some((author) => typeof author !== 'string') ||
        typeof item.submittedAt !== 'string' ||
        !Number.isFinite(Date.parse(item.submittedAt)) ||
        (item.kind !== 'wording' && typeof item.readerId !== 'string') ||
        typeof item.language !== 'string' ||
        !item.contentCheck ||
        !['clear', 'flagged', 'unavailable'].includes(item.contentCheck.status) ||
        !Array.isArray(item.contentCheck.signals) ||
        typeof item.containsSpoilers !== 'boolean' ||
        (item.publishedBody !== null && typeof item.publishedBody !== 'string') ||
        (item.kind === 'thought' &&
          (!item.quote ||
            typeof item.quote.id !== 'string' ||
            typeof item.quote.body !== 'string' ||
            !Number.isSafeInteger(item.quote.version) ||
            item.quote.version < 1 ||
            !Number.isSafeInteger(item.quote.captureVersion) ||
            item.quote.captureVersion < 1 ||
            !['approved', 'unreviewed', 'hidden'].includes(item.quote.status) ||
            typeof item.quote.language !== 'string')) ||
        !Number.isSafeInteger(item.readerCount) ||
        item.readerCount < 0,
    )
  )
    throw new AdminApiError(200, 'ADMIN_RESPONSE_INVALID');
  return value;
}
export const labels = {
  shared: c.shared,
  wording: c.wording,
  thought: c.thought,
};
export const control = 'admin-button';
export const initialFilters: AdminReviewFilters = { checkStatus: null, reviewerIds: [] };
export function moderationKey(item: QuoteModerationItem) {
  return `${item.kind}:${item.id}`;
}

export type PairDecision = 'approve_both' | 'quote_only' | 'decline_thought';
export function reviewKey(item: QuoteModerationItem) {
  return `${moderationKey(item)}:${item.version}:${item.quote?.version ?? ''}:${item.quote?.captureVersion ?? ''}`;
}
